import { request } from "@/network/request.js";
import { detailRequest } from "@/network/detailRequest.js";

//获取稿件详情
// export function getDetails(data) {
//     return request({
//         url: "/wpindex/query/detail",
//         params:data
//     })
// }
export function getDetails(data) {
    return detailRequest({
        url: "/api-new/v1/detail",
        params:data
    })
}
//获取专题详情
export function getFeatureDetails(data) {
    return request({
        url: "/wpindex/query/feature/detail",
        params:data
    })
}
//video 页面接口
export function getVideos(data) {
    return request({
        url: "/wpindex/query/videos",
        params:data
    })
}
//搜索
export function getSearch(data) {
    return request({
        url: "/wpindex/search",
        method:'POST',
        data
    })
}

export function getPreview(data) {
    return request({
        url: "/wpindex/query/preview",
        params:data
    })
}


export function getPreviewFeature(data) {
    return request({
        url: "/wpindex/query/feature/detail",
        params:data
    })
}

export function getPoserData(data) {
    return request({
        url: "/wpindex/create/poster",
        params:data
    })
}


export function getMoreData(data) {
    return request({
        url: "/wpindex/query/related",
        params:data
    })
}
export function getPosterImg(data) {
    return request({
        url: "/wpindex/get/poster",
        params:data
    })
}

// 预览海报图片
export function getPreviewPoster(data) {
    return request({
        url: "/wpindex/get/poster2",
        params:data
    })
}

export function getPlayurl(data) {
    return request({
        url: "/wpindex/get/playurl",
        params:data
    })
}

export function setlike(data) {
    return request({
        url: "/wpindex/like",
        params:data
    })
}


export function getPreviewDetails(data) {
    return request({
        url: "wpindex/mobile/detail",
        params:data
    })
}



export function setShareHtml(data) {
    return request({
        url: "/wpindex/share",
        method:'POST',
        data
    })
}

export function getShortUrl(data) {
    return request({
        url: "/wpshort",
        method:'GET',
        params:data
    })
}

export function getLiveUrl() {
    return request({
        url: '/wpindex/stream/pullUrl',
        method: 'GET'
    })
}